import React, { useEffect, useState } from "react";
import { Dayjs } from "dayjs";
import { SelectInputComponent } from "../../../../common/components";
import { CREATED_TIME_OPTIONS } from "../lead-filter.constant";
import CustomDateRangePicker from "../../../leads/lead-filter/lead-filter-options/custom-date-picket";
import { calculateDateRange } from "../../../../utils/filtersUtil";

interface LastActivityTimeFilterProps {
  value: string[];
  onChange: (value: string[]) => void;
  isLastActivityTimeEnabled?: boolean;
  onDateRangeChange: (fromDate: Date | null, toDate: Date | null) => void;
  lastActivityTimeError?: string;
  lastActivityTimeStartError?: string;
  lastActivityTimeEndError?: string;
  setLastActivityFromDate: (date: Dayjs | null) => void;
  setLastActivityToDate: (date: Dayjs | null) => void;
}

const LastActivityTimeFilter: React.FC<LastActivityTimeFilterProps> = ({
  value,
  onChange,
  isLastActivityTimeEnabled,
  onDateRangeChange,
  lastActivityTimeError,
  lastActivityTimeStartError,
  lastActivityTimeEndError,
  setLastActivityFromDate,
  setLastActivityToDate
}) => {
  const [showCustomDate, setShowCustomDate] = useState(false);
  const [selectOpen, setSelectOpen] = useState(false);
  const handleOpen = () => {
    setSelectOpen(true)
  }
  const handleBlur = () => {
    setSelectOpen(false)
  }
  useEffect(() => {
    const selected = typeof value === "object" ? "" : value;
    setShowCustomDate(value.includes("Custom"));

    if (selected && selected !== "Custom") {
      const { from, to } = calculateDateRange(selected);
      onDateRangeChange(from ? from.toDate() : null, to ? to.toDate() : null);
    }
  }, [value]);

  const handleCustomRangeChange = (from: Dayjs | null, to: Dayjs | null) => {
    onDateRangeChange(from?.toDate() || null, to?.toDate() || null);
  };
  if (!isLastActivityTimeEnabled) return null;


  return (
    <div className="filter-select-input-wrapper">
      <SelectInputComponent
        fieldName="lastActivityTime"
        options={CREATED_TIME_OPTIONS}
        onChange={onChange}
        value={value}
        placeholder=" Select Last Activity Time"
        //multiple={true}
        isFilter={true}
        selectOpen={selectOpen}
        handleOpen={handleOpen}
        handleBlur={handleBlur}
      />
      {lastActivityTimeError && <div className="error-text">{lastActivityTimeError}</div>}
      {showCustomDate && (
        <div>
          <CustomDateRangePicker
           onDateRangeChange={handleCustomRangeChange} 
           startDateError={lastActivityTimeStartError}
            endDateError={lastActivityTimeEndError}
            setFromDate={setLastActivityFromDate}
            setToDate={setLastActivityToDate}
             />
        </div>
      )}
    </div>
  );
};

export default LastActivityTimeFilter;
